<div
  class="flex flex-col info-wrapper min-h-full h-full py-6 px-4 md:py-8 md:px-6"
  [class.collapsed]="collapsed()"
  [class.gap-4]="!collapsed()"
  [class.disabled]="disabled"
  [class.mb-12]="!hideButtons"
  [class.md:mb-16]="!hideButtons"
>
  <div class="info-wrapper-header flex flex-row justify-between">
    <span class="font-medium text-base md:text-lg">
      {{ 'profile.addAccount.bankInformation' | translate }}
    </span>
    <div class="flex flex-row gap-2">
      <app-tag [type]="bankInfoStatus.tagType">
        {{ bankInfoStatus.localizableText | translate }}
      </app-tag>
      @if (collapsable) {
        <button nz-button nzType="text" class="collapse-button" (click)="onCollapseClick()">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M19.7803 16.0303C19.4874 16.3232 19.0126 16.3232 18.7197 16.0303L12 9.3107L5.2803 16.0303C4.9874 16.3232 4.5126 16.3232 4.2197 16.0303C3.9268 15.7374 3.9268 15.2626 4.2197 14.9697L11.4697 7.7197C11.7626 7.4268 12.2374 7.4268 12.5303 7.7197L19.7803 14.9697C20.0732 15.2626 20.0732 15.7374 19.7803 16.0303Z"
                fill="#505760"
              />
            </svg>
          </i>
        </button>
      }
    </div>
  </div>
  <div class="collapsable-content flex flex-col gap-4 relative" [class.pointer-events-none]="disabled">
    <div class="disabled-shield"></div>
    @if (bankNameIsDeclined || accountHolderIsDeclined) {
      <div class="mt-2 mb-4 flex flex-col gap-2">
        @if (bankNameIsDeclined) {
          <app-alert type="danger" localizableText="profile.theBankNameProvidedIsInvalid" [closable]="false" />
        }
        @if (accountHolderIsDeclined) {
          <app-alert type="danger" localizableText="profile.theAccountHoldersNameDoesNotMatch" [closable]="false" />
        }
      </div>
    }
    @if (!disabled && accountCountryIsMX && isAdding) {
      <div class="mt-2 mb-4">
        <app-alert type="info">
          {{ 'profile.someMexicanBanks' | translate }}
          <span class="!font-bold">{{ 'profile.mexicanbanks' | translate }}</span>
          {{ 'profile.supportUSDAccounts' | translate }}
        </app-alert>
      </div>
    }
    <korviu-select
      [label]="'profile.accountType' | translate"
      [options]="[
        { id: AccountCountries.US, value: 'profile.usAccount' | translate },
        { id: AccountCountries.MX, value: 'profile.mexicanAccount' | translate }
      ]"
      [control]="accountTypeControl"
      [disable]="disabled"
      size="large"
    ></korviu-select>
    @if (accountCountryIsMX) {
      <div class="country-select">
        <nz-radio-group [(ngModel)]="currency" (ngModelChange)="onCurrencyChange()">
          <label class="paragraph-medium regular" nz-radio [nzValue]="1">MXN</label>
          <label class="paragraph-medium regular" nz-radio [nzValue]="2">USD</label>
        </nz-radio-group>
      </div>
    }
    <div>
      <korviu-input
        [control]="bankNameControl"
        [label]="'profile.addAccount.bankName' | translate"
        size="large"
        [disabled]="disabled"
        [showErrorMessagesUnderField]="true"
      ></korviu-input>
    </div>
    @if (accountCountryIsUS) {
      <div>
        <korviu-input
          maskAccountNumber
          maxLength="9"
          size="large"
          [control]="routingNumberControl"
          [label]="'profile.addAccount.routingNumber' | translate"
          [onlyNumbers]="true"
          [showErrorMessagesUnderField]="true"
          [errorMessagesUnderField]="[
            {
              errorCode: 'mustContain',
              localizedMessage: 'profile.addAccount.validations.theRoutingNumberMustContain'
            },
            {
              errorCode: 'required',
              localizedMessage: 'profile.addAccount.validations.theRoutingNumberIsRequired'
            }
          ]"
          [disabled]="disabled"
        ></korviu-input>
      </div>
    }
    @if (accountCountryIsMX) {
      <div>
        <korviu-input
          maxLength="18"
          size="large"
          suffixIconType="eye-closed"
          [type]="'password'"
          [control]="clabeControl"
          [label]="'profile.addAccount.CLABE' | translate"
          [onlyNumbers]="true"
          [showErrorMessagesUnderField]="true"
          [errorMessagesUnderField]="[
            {
              errorCode: 'required',
              localizedMessage: 'profile.addAccount.validations.theCLABEIsRequired'
            },
            {
              errorCode: 'mustContain',
              localizedMessage: 'profile.addAccount.validations.theCLABEMustContain'
            }
          ]"
          [disabled]="disabled"
        ></korviu-input>
      </div>
    }
    @if (editMode && accountCountryIsMX) {
      <korviu-input
        [maxLength]="'18'"
        suffixIconType="eye-closed"
        [type]="'password'"
        [control]="confirmClabeControl"
        [label]="'profile.addAccount.confirmCLABE' | translate"
        [onlyNumbers]="true"
        size="large"
        [disabled]="disabled"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="[
          {
            errorCode: 'accountMismatch',
            localizedMessage: 'profile.addAccount.validations.accountNumbersMustMatchMX'
          }
        ]"
      ></korviu-input>
    }
    <div>
      <korviu-input
        [maxLength]="accountCountryIsMX ? '11' : '17'"
        suffixIconType="eye-closed"
        size="large"
        [type]="'password'"
        [control]="accountNumberControl"
        [label]="'profile.addAccount.accountNumber' | translate"
        [onlyNumbers]="true"
        [disabled]="disabled"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="accountNumberErrorMessages"
      ></korviu-input>
    </div>
    @if (editMode && !accountCountryIsMX) {
      <div>
        <korviu-input
          [maxLength]="accountCountryIsMX ? '11' : '17'"
          suffixIconType="eye-closed"
          [type]="'password'"
          [control]="confirmAccountNumberControl"
          [label]="'profile.addAccount.confirmAccountNumber' | translate"
          [onlyNumbers]="true"
          size="large"
          [disabled]="disabled"
          [showErrorMessagesUnderField]="true"
          [errorMessagesUnderField]="[
            {
              errorCode: 'accountMismatch',
              localizedMessage: 'profile.addAccount.validations.accountNumbersMustMatch'
            }
          ]"
        ></korviu-input>
      </div>
    }
    <div>
      <korviu-input
        maskAccountNumber
        [control]="holderFullName"
        [label]="'profile.accountHolderFullName' | translate"
        size="large"
        [disabled]="disabled"
        [showErrorMessagesUnderField]="true"
      ></korviu-input>
    </div>
  </div>
</div>
@if (!hideButtons) {
  <div class="buttons w-full flex flex-row gap-4 md:gap-8">
    <korviu-button class="flex-1" color="ghost" (onclick)="onBackClick()">
      {{ 'profile.addAccount.back' | translate }}
    </korviu-button>
    <korviu-button class="flex-1" color="tertiary" [disabled]="!formIsValid" (onclick)="onContinueClick()">
      {{ 'profile.addAccount.continue' | translate }}
    </korviu-button>
  </div>
}
